const {Pushes} = require("./pushes");
const {cbFunctions, getters, completer} = require("./cbFunctions");

$(document).ready(function () {
    document.setEvent();
});

document.setEvent = function(selector) {
    const eventElements = !selector ? $('.api-event') : $(`${selector} .api-event`);

    eventElements.click(function (e) {
        e.preventDefault();
        const api = new ApiEvents(this);

        api.sendEvent();
    });
}

class ApiEvents {
    #is_confirmed = true;

    constructor(event) {
        const $e = $(event);
        this.prepareData($e.data('data'));
        this.method = $e.data('event');
        this.url = this.getUrl($e);
        this.getCb($e);
        this.getter = $e.data('getter');

        if ($e.data('confirm') === true) {
            this.#is_confirmed = confirm($e.data('confirm-message'));
        }
    }

    prepareData(data) {
        this.data = data;
    }

    getUrl($e) {
        const parts = [
            '',
            $e.data('object')
        ];

        if (this.data) {
            parts.push(this.data.id);
        }

        return parts.join('/');
    }

    sendEvent() {
        if (!this.#is_confirmed) {
            return false;
        }

        const api = this;
        let request = getters[this.getter] === undefined ? this.data : getters[this.getter](this.data);

        if (request !== false) {
            $.ajax({
                url: this.url,
                method: this.method,
                dataType: 'json',
                data: request,
                headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
                success: function (data, textStatus, xhr) {
                    if (xhr.status === 204) {
                        return location.reload();
                    }

                    if (xhr.status === 200) {
                        if (api.cb !== undefined) {
                            return api.cb(data);
                        } else {
                            return new Pushes(data).success().show();
                        }
                    }

                    new Pushes('Something went wrong').error().show();
                },
                error: function (xhr) {
                    new Pushes(xhr.responseText || 'Something went wrong').error().show();
                },
                complete: data => {
                    if (typeof completer[this.getter] === 'function') {
                        completer[this.getter](data);
                    }
                }
            });
        }
    }

    getCb($e) {
        this.cb = cbFunctions[$e.data('cb')];
    }
}
